import { render, staticRenderFns } from "./purchaseSplitAction.vue?vue&type=template&id=cde02128&scoped=true"
import script from "./purchaseSplitAction.vue?vue&type=script&lang=js"
export * from "./purchaseSplitAction.vue?vue&type=script&lang=js"
import style0 from "./purchaseSplitAction.vue?vue&type=style&index=0&id=cde02128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde02128",
  null
  
)

export default component.exports